export default __webpack_public_path__ + "static/media/hht2_ani_01.fd11f928.png";